module.exports = __webpack_public_path__ + "img/Production.6bddc029.png";